import useMount from '@src/utils/hooks/use-mount';
import { observable } from 'mobx';
import { useRequest } from 'ahooks';
import getFooterYear from '@src/utils/get-footer-year';
import BaseStore from '@src/utils/store/base-store';
import Config from './config';
import SelectStore from '@src/business-components/common-language-select/store';
import langLocalesData from './langconfig.json';
import CookieTipsStore from '@src/business-components/common-footer/components/cookie-tips/store';
import ToTopBtnStore from '@src/business-components/to-top-btn/store';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import { noop } from '@src/utils/common-util';
const lang = getLanguageByPath();
const footerLocales = langLocalesData[lang]?.common_footer;

class FooterStore extends BaseStore {
  constructor(options = {}) {
    super(options);
    Object.assign(this, options);
  }

  @observable isActive = false;

  // 是否为瀑布流布局
  @observable isWaterfallLayout = false;

  //滚动到顶部
  @observable scrollToTop = noop;

  cookieTipsStore = new CookieTipsStore();

  selectStore = new SelectStore();

  // 当前年份
  @observable currentYear;

  // 协议跳转链接配置
  @observable agreementLinks = Config[lang]?.agreementLinks || [];

  // 底部左侧认证Logo
  @observable footerLeftLogo = Config[lang]?.footerLeftLogo || [];

  // 页脚功能链接
  @observable footerLinks = Config[lang]?.footerLinks || [];

  // 底部右侧Logo链接
  @observable footerRightLogo = Config[lang]?.footerRightLogo || [];

  // 处理Cookie设置
  handleCookieSetting() {
    this.cookieTipsStore.changeShowModalStatus(true);
    this.cookieTipsStore.onCookieSettingShowClick();
    this.cookieTipsStore.isDirectToSettingModal = true;
  }

  //回到顶部按钮
  toTopBtnStore = new ToTopBtnStore();

  //版权信息
  get footerTextInfo() {
    return [
      { href: '', text: `Copyright © ${this.currentYear} ${footerLocales.corporation}` },
      { href: '', text: footerLocales.purchase },
      { href: '', text: footerLocales.zh_text }
    ];
  }

  /**
   * 获取年份
   *
   */
  async getYear() {
    const year = await this.getCurrentYearRequest.run();
    this.currentYear = year;
  }

  use() {
    super.use();
    // 如果scrollToTop被赋值了，且是函数则赋值给toTopBtnStore的scrollToTop
    if (this.scrollToTop !== noop && typeof this.scrollToTop === 'function') {
      this.toTopBtnStore.scrollToTop = this.scrollToTop;
    }
    this.getCurrentYearRequest = useRequest(async () => await getFooterYear(), { manual: true, throwOnError: true });
    useMount(() => {
      this.getYear();
    });
  }
}

export default FooterStore;
